import { makeImage } from "../utils";
import housingAndCommunalServices from "./housing-and-communal-services.svg";

export const HousingAndCommunalServices = makeImage({
  src: housingAndCommunalServices,
  width: 64,
  height: 64,
  dataTestId: "housing-and-communal-services",
});
